import Env from 'shared/env';

export const SEND_MESSAGE_URL = build_url('/conversations/send/message');
export const SEND_MESSAGE_URL_V1 = build_url('/v1/chat/send/message');

function build_url(endpoint) {
  const origin = `${Env.vidioChatSecure() ? 'https' : 'http'}://${Env.vidioChatHost()}`;
  return `${origin}${endpoint}`;
}